export default __webpack_public_path__ + "static/media/ctq-logo.224348b6.png";